import { gql } from '@apollo/client';

export const GET_WAREHOUSE_BY_DESTINATION = gql`
  query GetWarehouseByDestination($destination: String!) {
    getWarehouseByDestination(destination: $destination)
  }
`;

export interface GetWarehouseByDestinationResponse {
  getWarehouseByDestination: string[];
}

export interface GetWarehouseByDestinationVariables {
  destination: string;
}

export const GET_ACCOUNT_BIND_WAREHOUSE = gql`
  query GetAccountBindWarehouse {
    warehouse: getAccountBindWarehouse {
      id
      name
      timezone
      timezoneLocation
      isClientCartonBatchInboundEnabled
      businessType
    }
  }
`;

export interface GetAccountBindWarehouseResponse {
  warehouse: {
    id: number;
    name: string;
    timezone: string;
    timezoneLocation: string;
    isClientCartonBatchInboundEnabled: boolean;
    businessType: number;
  };
}

export const CHECK_LOCATION_EXISTS = gql`
  query CheckLocationExists($locationNo: String!) {
    checkLocationExists(locationNo: $locationNo) {
      success
      messageKey
      requireConfirmation
      packageInfo {
        locationId
        locationNo
      }
    }
  }
`;

export interface WarehouseLocationScanResponse {
  success: boolean;
  messageKey?: string;
  requireConfirmation?: boolean;
  packageInfo?: {
    locationId: number;
    locationNo: string;
    trackingNumber?: string;
    locationOrderNo?: number;
    nextAction?: string;
    pickingActionDetail?: string;
  };
}

export interface CheckLocationExistsResponse {
  checkLocationExists: WarehouseLocationScanResponse;
}

export interface CheckLocationExistsVariables {
  locationNo: string;
}

export const GET_WAREHOUSE_DETAILS_BY_DESTINATION = gql`
  query GetWarehouseDetailsByDestination($destination: String!) {
    getWarehouseDetailsByDestination(destination: $destination) {
      id
      parentSiteId
      name
      siteType
      sortingCode
    }
  }
`;

export interface WarehouseDetailType {
  id: string; // GraphQL Long 类型在 JSON 中序列化为字符串
  parentSiteId: string; // GraphQL Long 类型在 JSON 中序列化为字符串，Hub 的 parentSiteId 为 "0"
  name: string;
  siteType: number; // 1=HUB, 2=WAREHOUSE
  sortingCode: string | null;
}

export interface GetWarehouseDetailsByDestinationResponse {
  getWarehouseDetailsByDestination: WarehouseDetailType[];
}

export interface GetWarehouseDetailsByDestinationVariables {
  destination: string;
}

// ===== PDA 装包扫描：SWX+TT 下一站选项 =====

export const GET_PDA_BAGGING_NEXT_STOP_OPTIONS = gql`
  query GetPdaBaggingNextStopOptions($destination: String) {
    getPdaBaggingNextStopOptions(destination: $destination) {
      code
      name
      source
    }
  }
`;

export interface PdaNextStopOption {
  code: string;
  name: string;
  source: string; // "SWIFTX" or "TT"
}

export interface GetPdaBaggingNextStopOptionsResponse {
  getPdaBaggingNextStopOptions: PdaNextStopOption[];
}

export interface GetPdaBaggingNextStopOptionsVariables {
  destination?: string;
}
